import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow } from "vue";
import _imports_0 from '../../assets/images/login/logo_pingtai.png';
import _imports_1 from '../../assets/images/login/ic_phone.png';
import _imports_2 from '../../assets/images/login/ic_capcha.png';
import _imports_3 from '../../assets/images/login/ic_lock.png';
const _hoisted_1 = {
  class: "login-box"
};
const _hoisted_2 = {
  class: "input-content"
};
const _hoisted_3 = {
  style: {
    "height": "220px"
  }
};
const _hoisted_4 = {
  class: "ipt user_icon"
};
const _hoisted_5 = {
  class: "ipt pwd_icon"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "ipt pwd_icon"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  style: {
    "height": "220px"
  }
};
const _hoisted_10 = {
  class: "ipt user_icon"
};
const _hoisted_11 = {
  class: "ipt pwd_icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[17] || (_cache[17] = _createElementVNode("h2", {
    class: "title"
  }, [_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "ic"
  }), _createTextVNode(" 宣传素材管理平台 ")], -1)), _withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "icon"
  }, null, -1)), _withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入手机号",
    onKeyup: _cache[0] || (_cache[0] = _withKeys((...args) => $setup.handleLogin && $setup.handleLogin(...args), ["enter"])),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.phone = $event),
    autocomplete: "off",
    class: "login_txtbx"
  }, null, 544), [[_vModelText, _ctx.phone]])]), _createElementVNode("div", _hoisted_5, [_cache[13] || (_cache[13] = _createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "icon"
  }, null, -1)), _withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入图形验证码",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.captchaCode = $event),
    autocomplete: "off"
  }, null, 512), [[_vModelText, _ctx.captchaCode]]), _ctx.captcha ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "img-code",
    src: _ctx.captcha.image,
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.getCaptchaHandler && $setup.getCaptchaHandler(...args))
  }, null, 8, _hoisted_6)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_cache[14] || (_cache[14] = _createElementVNode("img", {
    src: _imports_3,
    alt: "",
    class: "icon"
  }, null, -1)), _withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入短信验证码",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.verifyCode = $event),
    autocomplete: "off",
    class: "login_txtbx",
    onKeyup: _cache[5] || (_cache[5] = _withKeys((...args) => $setup.handleLogin && $setup.handleLogin(...args), ["enter"]))
  }, null, 544), [[_vModelText, _ctx.verifyCode]]), _ctx.btnTitle ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "ver_btn",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.getVerifyCode && $setup.getVerifyCode(...args)),
    disabled: _ctx.disabled
  }, _toDisplayString(_ctx.btnTitle), 9, _hoisted_8)) : _createCommentVNode("", true)])], 512), [[_vShow, _ctx.loginType === '1']]), _withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[15] || (_cache[15] = _createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "icon"
  }, null, -1)), _withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入用户名",
    onKeyup: _cache[7] || (_cache[7] = _withKeys((...args) => $setup.handleLogin && $setup.handleLogin(...args), ["enter"])),
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _ctx.account = $event),
    autocomplete: "off",
    class: "login_txtbx"
  }, null, 544), [[_vModelText, _ctx.account]])]), _createElementVNode("div", _hoisted_11, [_cache[16] || (_cache[16] = _createElementVNode("img", {
    src: _imports_3,
    alt: "",
    class: "icon"
  }, null, -1)), _withDirectives(_createElementVNode("input", {
    type: "password",
    placeholder: "请输入密码",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.password = $event),
    autocomplete: "off",
    class: "login_txtbx",
    onKeyup: _cache[10] || (_cache[10] = _withKeys((...args) => $setup.handleLogin && $setup.handleLogin(...args), ["enter"]))
  }, null, 544), [[_vModelText, _ctx.password]])])], 512), [[_vShow, _ctx.loginType === '2']]), _createElementVNode("button", {
    class: "login",
    onClick: _cache[11] || (_cache[11] = (...args) => $setup.handleLogin && $setup.handleLogin(...args))
  }, "登  录")])]);
}